<template>
  <div>

    <SettingGroup title="オプション">
      <SettingItem label="電源オン時のスキャン">
        <ToggleSwitch
          v-model="form.toggle.option.powerOnScan"
          :disable="false"
        />
      </SettingItem>

      <SettingItem label="スキャン時の送信グループ">
        <!-- RadioGroup: v-model:modelValue -> :value + @input -->
        <RadioGroup
          :value="form.radioBtn.option.selectScanGroup"
          :options="radioBtnOptions.option.selectScanGroup"
          :disable="false"
          @input="val => form.radioBtn.option.selectScanGroup = val"
        />
      </SettingItem>
    </SettingGroup>
  </div>
</template>

<script>
import ColorSelectBox from '@/components/pc/radio/ipradio/atoms/ColorSelectBox.vue'
import RadioGroup from '@/components/pc/radio/ipradio/atoms/RadioGroup.vue'
import ToggleSwitch from '@/components/pc/radio/ipradio/atoms/ToggleSwitch.vue'
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import SettingItem from '@/components/pc/radio/ipradio/organisms/layout/SettingItem.vue'
import { BC, BC_TRANS_JP } from '@/components/pc/radio/ipradio/config/BCconstants'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'
import { mapStores } from 'pinia'

export default {
  name: 'ScanGeneralVue2',
  components: {
    ColorSelectBox, RadioGroup, ToggleSwitch, SettingGroup, SettingItem,
  },
  data () {
    // ラジオとセレクトの選択肢生成
    const radioBtnOptions = {
      option: {
        selectScanGroup: Object.keys(BC.SCAN_INFORMATION.GENERAL.OPTION.SELECT_SCAN_GROUP).map(key => ({
          label: BC_TRANS_JP.SCAN_INFORMATION.GENERAL.OPTION.SELECT_SCAN_GROUP[key],
          value: BC.SCAN_INFORMATION.GENERAL.OPTION.SELECT_SCAN_GROUP[key],
        })),
      },
    }

    return {
      radioBtnOptions,
      // フォーム
      form: {
        toggle: {
          option: { powerOnScan: false },
        },
        radioBtn: {
          option: {
            selectScanGroup: radioBtnOptions.option.selectScanGroup[0].value,
          },
        },
      },
      // ストア設定の参照
      setting: null,
    }
  },
  computed: {
    ...mapStores(useRadioSettingsStore),
  },
  created () {
    // ストアから一時設定を取得
    this.setting = this.radioSettingsStore.getTempSetting()

    // 設定 → フォームへ反映
    this.transSetting2Form()

    // フォーム変更を監視：設定へ反映し保存
    this.$watch('form', () => {
      this.transForm2Setting()
      this.radioSettingsStore.saveTempSetting(this.setting)
    }, { deep: true })
  },
  methods: {
    // 設定 ← フォーム
    transForm2Setting () {
      const data = this.setting?.ScanInformation?.General
      if (!data) return

      data.Option['Power-onScan'] = this.form.toggle.option.powerOnScan
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE

      data.Option.SelectScanGroup = this.form.radioBtn.option.selectScanGroup
    },

    // 設定 → フォーム
    transSetting2Form () {
      const data = this.setting?.ScanInformation?.General
      if (!data) return

      this.form.toggle.option.powerOnScan =
        data.Option['Power-onScan'] === BC.COMMON.TOGGLE.ENABLE

      this.form.radioBtn.option.selectScanGroup = data.Option.SelectScanGroup
    },
  },
}
</script>
